module.exports = __webpack_public_path__ + "static/img/splitRadar.adde4bda.svg";